
<template>
  <div>
     <b-button
      v-permission="'lessons.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      :service="service"
      route_name="lessons"
      order_column="name">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('lesson.name') }}</vs-th>
        <vs-th key="description" sort-key="description">{{ $t('lesson.description') }}</vs-th>
        <vs-th key="sale">{{ $t('catalog.listing.column') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="25%" key="name">
            <div> {{ tr.name }}</div>
          </vs-td>
          <vs-td width="35%" key="description">
            <div v-html-safe="tr.description"></div>
          </vs-td>
          <vs-td width="15%" key="sale">
            <div class="flex flex-row gap-2 items-center">
              <sale-status-badge :sale="saleMap[tr.id]" :plan-only="!!tr.plan_only"/>
              <feather-icon
                v-if="!tr.plan_only && !isPublished(tr.id)"
                v-permission="'lessons.edit'"
                icon="PlayCircleIcon"
                class="h-5 w-5 stroke-current text-primary cursor-pointer"
                v-tooltip.auto="{ content: $t('catalog.listing.resume'), delay: { show: 500, hide: 100 } }"
                @click="resumeSale(tr.id)"/>
              <a
                v-else-if="!tr.plan_only && listingUrl(tr.id)"
                :href="listingUrl(tr.id)"
                target="_blank"
                rel="noopener"
                v-tooltip.auto="{ content: $t('catalog.listing.see'), delay: { show: 500, hide: 100 } }">
                <feather-icon icon="ExternalLinkIcon" class="h-5 w-5 stroke-current text-success"/>
              </a>
            </div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'lessons.show'"
                icon="CalendarIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
                v-tooltip.auto="{
                  content: $t('lesson.agenda.title'),
                  delay: { show: 500, hide: 100 },
                }"
                @click="openAgenda(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'lessons.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'lessons.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import LessonService from '@/services/api/LessonService'
import ProductService from '@/services/api/ProductService'
import SaleStatusBadge from '@/components/catalog/SaleStatusBadge.vue'
import { marketplaceItemUrl } from '@/components/catalog/catalog'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    SaleStatusBadge
  },
  data: () => ({
    selected: [],
    service: null,
    /** aula id → linha do mapa item→produto (situação de venda). */
    saleMap: {}
  }),
  methods: {
    addNew() {
      this.$router.push('/lessons/create')
    },
    openAgenda(id) {
      this.$router.push(`/lessons/${id}/agenda`)
    },
    resumeSale(id) {
      this.$router.push(`/lessons/${id}/edit?step=venda`)
    },
    isPublished(id) {
      const sale = this.saleMap[id]
      return !!sale && sale.status === 'RE'
    },
    listingUrl(id) {
      const sale = this.saleMap[id]
      return sale ? marketplaceItemUrl('LES', sale.product_id) : null
    },
    loadSaleMap() {
      // Uma chamada para a listagem inteira; quem não tem permissão de
      // produto simplesmente fica sem a coluna preenchida.
      ProductService.build(this.$vs).getItemsMap('LES').then(rows => {
        const map = {}
        ;(Array.isArray(rows) ? rows : []).forEach(row => {
          if (!map[row.model_id] || row.status === 'RE') {
            map[row.model_id] = row
          }
        })
        this.saleMap = map
      }).catch(() => {})
    }
  },
  beforeMount() {
    this.service = LessonService.build(this.$vs)
  },
  mounted() {
    this.loadSaleMap()
  }
}
</script>
